import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import { Input } from "antd";

@autobind
/**
 *
 */
export default class TextArea extends Base {
  static propTypes = {
    ...Base.propTypes,
    addonAfter: PropTypes.node,
  };

  /**
   *
   * @return {Object}
   * @protected
   */
  get _props() {
    return this.props.$omit(["addonAfter"]);
  }

  /**
   *
   * @return {XML}
   */
  get _component() {
    return (
      <Input.TextArea
        autosize={{ minRows: 3, maxRows: 5 }}
        dir="auto"
      />
    );
  }

  /**
   *
   * @return {XML}
   */
  get _suffix() {
    return (
      <div
        className="ant-input-group-addon right-1"
        style={{
          position: "absolute",
          top: 1,
          width: "inherit",
          border: "1px solid #d9d9d9",
          borderRadius: 4,
          lineHeight: "22px",
        }}
      >
        {this.props.addonAfter}
      </div>
    );
  }
}
